<div class="page-container">

  <div class="container">
    <app-reference-preview *ngFor="let reference of references |  sort: 'createdAt' : true; let i = index" [reference]="reference" [index]="i"></app-reference-preview>
  </div>
</div>
